var AddressComponentState;
(function (AddressComponentState) {
    AddressComponentState["READONLY_ADDRESS"] = "readonly-address";
    AddressComponentState["ADD_NEW_DELIVERY_ADDRESS"] = "add-new-delivery-address";
    AddressComponentState["ADD_NEW_INVOICE_ADDRESS"] = "add-new-invoice-address";
    AddressComponentState["EDIT_DELIVERY_ADDRESS"] = "edit-delivery-address";
    AddressComponentState["EDIT_INVOICE_ADDRESS"] = "edit-invoice-address";
    AddressComponentState["SHOW_SAVED_ADDRESSES"] = "show-saved-addresses";
})(AddressComponentState || (AddressComponentState = {}));

export { AddressComponentState };
//# sourceMappingURL=index.js.map
